import React from 'react';
import classNames from 'classnames';
import uniqueId from 'uniqid';
import { FiChevronDown } from 'react-icons/fi';
import RenderStaticHTML from '../RenderStaticHTML';
import {
	Accordion,
	AccordionItem,
	AccordionControl,
	AccordionPanel
} from '../Accordion';

const ns = `faqs`;

const Faqs = ({
	faqItems,
	variantB,
}) => {
	const rootClassnames = classNames({
		[`${ns}`]: true,
	});

	const faqItemsParsed = faqItems !== null ? JSON.parse(faqItems?.value) : null;

	return (
		<section className={`${rootClassnames}`} style={variantB && {backgroundColor: '#FFF'}}>
			<div className="container">
				<h3>FAQs</h3>
				<Accordion>
				{faqItemsParsed && faqItemsParsed.map((faq) => {
					return (
						<AccordionItem key={uniqueId('nn-faq')}>
							<AccordionControl>
								<span className="h4">{faq.question}</span>
								<span><FiChevronDown size={24} /></span>
							</AccordionControl>
							<AccordionPanel>
								<RenderStaticHTML html={faq.answer} />
							</AccordionPanel>
						</AccordionItem>
					);
				})}
				</Accordion>
			</div>
		</section>
	);
};

export default Faqs;
